export default __webpack_public_path__ + "static/media/Republic4.a65556ac.png";